module.exports = __webpack_public_path__ + "static/requiredFormatYes-010fc8bebcde2aee3ca159ea8b3ceb66.png";